(function () {
    if (document.querySelectorAll('.blade-light-switch').length > 0) {
        document.querySelectorAll('.blade-light-switch').forEach(function (element) {
            element.addEventListener('click', function () {
                var target = element.querySelector('.blade-light-switch-input');

                if (target) {
                    // Toggle the target checkbox
                    target.checked = !target.checked;
                    element.classList.toggle('light-switch-checked');
                }
            });
        });
    }
})();
